/**
 * Created by Admin on 25.05.2018.
 */
import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import PropTypes from 'prop-types'

import Tooltip from '@material-ui/core/Tooltip'

const styles = theme => ({
  primary: {
    padding: '10px 16px',
    color: 'var(--color-text-on-primary)',
    background: 'var(--color-button-primary)',
    borderColor: 'var(--color-button-primary)',
    border: '1px solid',
    outline: 'none',
    cursor: 'pointer',
    borderRadius: 10,
    lineHeight: 'normal',
    fontFamily: 'Lato',
    minWidth: 78,
    fontSize: 14,
    '&:hover': {},
    '&:disabled': {
      cursor: 'default',
      backgroundColor: 'var(--color-text-placeholder)',
      border: 'none',
    },
  },
  primary_with_border: {
    padding: '10px 16px',
    color: 'var(--color-button-primary)',
    background: 'var(--color-white)',
    borderColor: 'var(--color-button-primary)',
    border: '1px solid',
    outline: 'none',
    cursor: 'pointer',
    borderRadius: 10,
    lineHeight: 'normal',
    fontFamily: 'Lato',
    minWidth: 78,
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {},
    '&:disabled': {
      cursor: 'default',
      backgroundColor: 'var(--color-pressed-overlay-primary)',
      color: 'var(--color-text-on-primary)',
      borderColor: 'var(--color-pressed-overlay-primary)',
    },
    '& > svg': {
      marginRight: 10,
    },
  },
  secondary: {
    padding: '10px 16px',
    color: 'var(--color-text-on-secondary)',
    background: 'var(--color-button-secondary)',
    borderColor: 'var(--color-button-secondary)',
    border: '1px solid',
    outline: 'none',
    cursor: 'pointer',
    borderRadius: 10,
    lineHeight: 'normal',
    fontFamily: 'Lato',
    minWidth: 78,
    fontSize: 14,
    '&:hover': {},
    '&:disabled': {
      cursor: 'default',
      backgroundColor: 'var(--color-athens-grey)',
      color: 'var(--color-mischka-grey)',
      borderColor: 'var(--color-mischka-grey)',
    },
  },
  secondary_with_border: {
    padding: '10px 16px',
    color: 'var(--color-button-secondary)',
    background: 'var(--color-white)',
    borderColor: 'var(--color-button-secondary)',
    border: '1px solid',
    outline: 'none',
    cursor: 'pointer',
    borderRadius: 10,
    lineHeight: 'normal',
    fontFamily: 'Lato',
    minWidth: 78,
    fontSize: 14,
    '&:hover': {},
    '&:disabled': {
      cursor: 'default',
      backgroundColor: 'var(--color-pressed-overlay-secondary)',
      color: 'var(--color-text-on-secondary)',
      borderColor: 'var(--color-pressed-overlay-secondary)',
    },
  },
  warning: {
    padding: '10px 16px',
    color: '#FF6666',
    background: 'none',
    borderColor: 'none',
    border: '0px',
    outline: 'none',
    cursor: 'pointer',
    borderRadius: 10,
    lineHeight: 'normal',
    fontFamily: 'Lato',
    minWidth: 78,
    fontSize: 14,
  },
  default: {
    padding: '8px 16px',
    background: theme.defaults.contrastText,
    border: '1px solid',
    borderColor: theme.defaults.gray,
    color: theme.defaults.headerText,
    borderRadius: 10,
    fontSize: 14,
    lineHeight: 1,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  noStyle: {
    color: theme.defaults.headerText,
    textDecoration: 'underline',
    border: 'none',
    background: 'transparent',
    padding: '0',
    fontSize: 14,
    fontWeight: '600',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  sizeSm: {
    padding: '8px 16px',
  },
  sizeLg: {
    padding: '14px 28px',
  },
  cancel: {
    backgroundColor: 'unset',
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontSize: 14,
    color: 'var(--color-text-secondary)',
    padding: '8px 28px',
    border: 'none',
    '&:hover': {
      cursor: 'pointer',
    },
    '& > svg': {
      marginRight: 10,
    },
  },
  empty: {
    background: theme.defaults.contrastText,
    color: theme.palette.primary.main,
    border: '1px solid',
    borderColor: theme.palette.primary.main,
  },
})

class SubmitButton extends React.Component {
  render() {
    const { classes, type, size, className, dataAutotest, icon } = this.props
    const classButton = `${type ? classes[type] : classes.primary} ${this.props.empty && classes.empty}`
    const buttonSizeClass = size === 'sm' ? classes.sizeSm : size === 'lg' ? classes.sizeLg : ''

    return this.props.tooltip ? (
      <Tooltip title={this.props.tooltip}>
        <button
          disabled={this.props.disabled}
          className={`${classButton} ${buttonSizeClass} ${className}`}
          onClick={e => this.props.onClick && this.props.onClick(e)}
          data-autotest={dataAutotest || null}
          style={this.props.styles}>
          {this.props.title}
        </button>
      </Tooltip>
    ) : (
      <button
        disabled={this.props.disabled}
        className={`${classButton} ${buttonSizeClass} ${className}`}
        onClick={e => this.props.onClick && this.props.onClick(e)}
        data-autotest={dataAutotest || null}
        style={this.props.styles}>
          {icon}
        {this.props.title}
      </button>
    )
  }
}

SubmitButton.propTypes = {
  classes: PropTypes.object,
  styles: PropTypes.object,
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  empty: PropTypes.bool,
  icon: PropTypes.node,
  onClick: PropTypes.func,
}

export default withStyles(styles, { withTheme: true })(SubmitButton)
